import React from 'react';
import PropTypes from 'prop-types';
import Accordion from 'components/Accordion';
import QuestionBlock from './components/QuestionBlock';
// eslint-disable-next-line import/no-cycle
import AnswerBlock from './components/AnswerBlock';

import styles from './styles.module.scss';

const StyledContentSpoiler = ({
	data,
	getSpoilerRefs,
	onSpoilerClick,
	getSpoilerContentHeight,
	activeSpoiler,
	blockKey
}) => (
	<Accordion
		className={styles.Spoiler}
		renderButton={(title, isActive) => (
			<QuestionBlock title={title} isActive={isActive} />
		)}
		renderChildren={(content) => <AnswerBlock content={content} />}
		data={data}
		getRefs={getSpoilerRefs}
		onButtonClick={onSpoilerClick}
		getContentHeight={getSpoilerContentHeight}
		activeItem={activeSpoiler}
		itemKey={blockKey}
	/>
);

StyledContentSpoiler.propTypes = {
	data: PropTypes.shape({
		header: PropTypes.string.isRequired,
		content: PropTypes.array
	}).isRequired,
	getSpoilerRefs: PropTypes.func,
	onSpoilerClick: PropTypes.func,
	getSpoilerContentHeight: PropTypes.func,
	activeSpoiler: PropTypes.string,
	blockKey: PropTypes.string
};

export default StyledContentSpoiler;
